// 繁体中文语言包
export default {
  // 通用
  common: {
    confirm: '確認',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '查詢',
    add: '新增',
    edit: '編輯',
    delete: '刪除',
    remove: '移除',
    save: '保存',
    close: '關閉',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    loading: '加載中...',
    noData: '暫無數據',
    operation: '操作',
    status: '狀態',
    createTime: '創建時間',
    updateTime: '更新時間',
    actions: '操作',
    success: '成功',
    fail: '失敗',
    warning: '警告',
    error: '錯誤',
    tips: '提示',
    pleaseSelect: '請選擇',
    pleaseInput: '請輸入',
    normal: '正常',
    disabled: '停用'
  },

  // 登录相关
  login: {
    title: '登錄',
    personalLogin: '個人登錄',
    enterpriseLogin: '企業登錄',
    username: '用戶名',
    password: '密碼',
    phone: '手機號',
    verifyCode: '驗證碼',
    getVerifyCode: '獲取驗證碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼',
    loginButton: '登錄',
    register: '註冊',
    logout: '退出登錄'
  },

  // 用户中心
  userCenter: {
    title: '用戶中心',
    account: '賬號管理',
    message: '消息通知',
    approval: '我的審批',
    identity: '身份認證',
    admin: '企業管理員'
  },

  // 消息相关
  message: {
    title: '消息通知',
    unread: '未讀',
    read: '已讀',
    starred: '標星',
    all: '全部',
    system: '系統消息',
    business: '業務消息',
    activity: '活動消息',
    noMessage: '暫無消息',
    noMessageDetail: '暫無消息詳情',
    markAsRead: '標記為已讀',
    markAsUnread: '標記為未讀',
    star: '標星',
    unstar: '取消標星',
    delete: '刪除消息',
    time: '時間',
    sender: '發送者'
  },

  // 审批相关
  approval: {
    title: '我的審批',
    pending: '待審批',
    approved: '已通過',
    rejected: '已駁回',
    applicant: '申請人',
    approver: '審批人',
    businessType: '業務類型',
    approvalStatus: '審批狀態',
    remark: '備註',
    approve: '通過',
    reject: '駁回',
    approvalTime: '審批時間',
    sendApproval: '發送審批',
    approvalResult: '審批結果'
  },

  // 工作台
  workbench: {
    title: '工作台',
    salesman: '業務員管理',
    user: '用戶管理',
    addSalesman: '新增業務員',
    salesmanName: '業務員姓名',
    idCard: '身份證',
    phone: '聯繫電話',
    inviteTime: '邀請時間',
    removeSalesman: '移除業務員',
    confirmRemoveSalesman: '確定要移除業務員"{name}"嗎？',
    removeSuccess: '刪除成功',
    removeFail: '刪除失敗，請重試',
    inviteSuccess: '審批申請已發送，等待對方確認',
    inviteFail: '發送審批申請失敗，請重試',
    serialNumber: '序號',
    loadListFail: '加載業務員列表失敗',
    cannotGetEnterpriseInfo: '無法獲取當前企業信息',
    inviteSalesmanRemark: '邀請{name}成為業務員',
    placeholderSalesmanName: '請輸入業務員姓名',
    placeholderPhone: '請輸入聯繫電話',
    statusChangeSuccess: '狀態修改成功',
    statusChangeFail: '狀態修改失敗，請重試',
    enable: '啟用',
    disable: '禁用',
    confirmStatusChange: '確定要{status}業務員"{name}"嗎？'
  },

  // 企业管理员
  enterpriseAdmin: {
    title: '企業管理員',
    addAdmin: '邀請管理員',
    refresh: '刷新',
    adminName: '管理員姓名',
    adminPhone: '管理員手機號',
    adminStatus: '管理員狀態',
    adminType: '管理員類型',
    removeAdmin: '移除管理員',
    confirmRemoveAdmin: '確定要移除管理員"{name}"嗎？',
    removeSuccess: '移除成功',
    removeFail: '移除失敗，請重試',
    statusChangeSuccess: '狀態修改成功',
    statusChangeFail: '狀態修改失敗，請重試'
  },

  // 邀请对话框
  inviteDialog: {
    title: '邀請個人用戶',
    inviteeIdCard: '受邀人身份證',
    inviteePhone: '受邀人手機號碼',
    inviteeInfo: '受邀人詳細信息：',
    refreshQuery: '刷新查詢',
    queryAccount: '受邀人賬號查詢',
    nickname: '暱稱',
    realName: '真實姓名',
    idCard: '身份證',
    phone: '手機號',
    verifiedStatus: '實名認證狀態',
    isAdmin: '是否為管理員',
    isSalesman: '是否為機構業務員',
    verified: '已認證',
    unverified: '未認證',
    verifying: '認證中',
    rejected: '未通過',
    yes: '是',
    no: '否',
    sendSmsCode: '發送驗證碼',
    resendSmsCode: '秒後重發',
    verifyCode: '受邀人手機驗證碼',
    pleaseInputVerifyCode: '請輸入受邀人手機驗證碼',
    confirmInvite: '確認受邀人為業務員',
    confirmInviteAdmin: '確認受邀人為管理員',
    querySuccess: '查詢成功',
    queryFail: '查詢用戶信息失敗，請重試',
    notFound: '未找到匹配的用戶信息',
    pleaseFillForm: '請填寫完整的表單信息',
    pleaseFillIdCardAndPhone: '請先填寫身份證號和手機號',
    pleaseQueryFirst: '請先查詢受邀人信息'
  },

  // 表单验证
  validation: {
    required: '此項為必填項',
    idCardFormat: '請輸入正確的身份證號碼',
    phoneFormat: '請輸入正確的手機號碼',
    emailFormat: '請輸入正確的郵箱地址',
    minLength: '長度不能少於{min}個字符',
    maxLength: '長度不能超過{max}個字符'
  }
}

